/**
 * Login
 */
//New Stuff
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

// React
import React, { useState, useEffect, Fragment, useRef } from 'react';

// Helmet
import { Helmet } from 'react-helmet';

// UI
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  Avatar,
  Grid,
  CircularProgress,
  Paper,
  Typography,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
// Helper
import { changePhoneNumberFormatTo98, fixNumbers } from '../../utils/helpers';

// Type
import { Props } from './interfaces';
import loginRepository from 'client-sdk/src/Repository/login-repository';
import handleError from '../../utils/handleError';
import RonadIcons from '../../components/iconComponent';
import handleNotfication from '../../utils/handleNotfication';
// utils
import decodeToken from '../../utils/decodeJwt';
import getEnv from '../../utils/getEnv';
// Style
const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
    overflow: 'hidden',
  },
  login: {
    main: "#24388D",
  },
  image: {
    backgroundImage: 'url("/login.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
    height: "100%",
    borderRadius: "10px",
    // margin: "10px",
    // backgroundColor:
    //   theme.palette.type === 'light'
    //     ? theme.palette.grey[50]
    //     : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'right bottom ',
    // marginBottom: '-30px',
    // marginRight:'10px',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  item: {
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    fontWeight: 500,
    width: '100%',
    margin: '0 auto',
    '& > *': {
      // margin: theme.spacing(0, 0, 0, 1),
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 400,
    color: '#8a8a8a',
    marginRight: '8px',
    marginTop: '21px',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    marginBottom: "25px",
    width: theme.spacing(29),
    height: theme.spacing(28),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    // margin: theme.spacing(1, 0, 3),
    // padding: theme.spacing(0, 8),
    textAlign: 'center',
    justifyContent: 'center'
  },
  error: {
    width: "329px",
    margin: theme.spacing(2, 0, 0),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
    width: "100%",
    height: theme.spacing(5),
  },
  imageContainer: {
    '@media (min-width: 960px)': {
      padding: "40px",
    },
    backgroundColor: "#fff"
  },
  mobileFirstNumber: {
    padding: "0 10px",
    borderLeft: "1px solid #000",
    margin: 0
  },
  errorMsg: {
    color: "red",
    textAlign: "left",
    margin: 0,
    fontSize: "14px"
  },
  infoContainer: {
    backgroundColor: "#FFF1F0",
    border: "1px solid #FFCCC7",
    fontSize: "14px",
    padding: "12px 16px",
    borderRadius: "2px",
    textAlign: "start",
    maxWidth: "327px"
  },
  formContainer: {
    position: 'relative',
    border: '1px solid #FFCCC7',
    padding: '5px 10px',
    borderRadius: '4px',
    '& $label': {
      position: 'absolute',
      backgroundColor: 'white',
      top: '-32px',
      left: '10px'
    }
  },
}));

function Login(props: Props) {
  const [emailAddress, setEmailAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [mode, setMode] = useState('default');
  const [rememberMe] = useState(true);
  const [hide, setHide] = useState(true);
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [compeleteTimer, setCompeleteTimer] = useState(false)
  const timeRef = useRef(null)
  const [shoudShowhint, setShouldShowHint] = useState(false)
  const history = useHistory();

  const { search } = useLocation();
  const queryValues = queryString.parse(search);



  const countdown = () => {
    setCompeleteTimer(false)
    let timer = 120, timerInt, minutes, seconds;
    timerInt = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      timeRef.current.textContent = minutes + ":" + seconds
      timer -= 1
      if (timer === -1) {
        setCompeleteTimer(true)
        clearInterval(timerInt)
        return
      }
    }, 1000)
  }

  const handleChangeEmailAddress = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEmailAddress(event.target.value);
  };
  const handleChangePhoneNumber = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPhoneNumber(event.target.value);
  };
  const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };
  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const login = async () => {
    setLoading(true)
    try {
      const response = await loginRepository.authentication({
        payload: {
          emailAddress,
          password,
          rememberMe,
        }
      })
      if (response?.data) {
        const userInfo = decodeToken(response.data.token)
        if (userInfo?.ssoStatus === "IN_PROGRESS" || !userInfo?.ssoStatus) {
          handleNotfication('ورود با موفقیت انجام شد', 'success');
          response?.data && localStorage.setItem('token', response?.data.token);
          response?.data && localStorage.setItem('role', response?.data.role);
          response?.data && localStorage.setItem('name', response?.data.name);
          response?.data?.vitrin &&
            localStorage.setItem('vitrin', response?.data.vitrin);
          response?.data?.warehouseId &&
            localStorage.setItem('warehouseId', response?.data.warehouseId);
          response?.data?.partnerId &&
            localStorage.setItem('partnerId', response?.data.partnerId);
          response?.data?.sellerIds &&
            localStorage.setItem('sellerIds', response?.data.sellerIds);
          response?.data?.userId &&
            localStorage.setItem('userId', JSON.stringify(response?.data.userId));
          setLoading(false)
          localStorage.setItem('logintype', 'partner')
          window.location.pathname !== '/login'
            ? window.location.replace(window.location.pathname)
            : window.location.replace('/orders');
        }
        else {
          setShouldShowHint(true)
        }
      }

    } catch (error) {
      setLoading(false)
      handleNotfication("رود ناموفق، لطفا نام‌کاربری و کلمه عبور را بررسی و دوباره امتحان نمایید", "error")
    }
  }

  const onSubmit = (e: any) => {
    e.preventDefault();

    if (mode === 'default' && emailAddress.length > 0 && password.length > 0) {
      login()
    } else if (mode === 'generateOpt') {
      if (!/^(\+989|09)\d{9}$/g.test(phoneNumber)) {
        setError(true)
        return
      }
      if (process.env.REACT_APP_ENVIROMENT == "sandbox") {
        generateDemoOtp({
          phoneNumber: changePhoneNumberFormatTo98(fixNumbers(`${phoneNumber}`)),
        })
      } else {
        generateOtp({
          phoneNumber: fixNumbers(`${phoneNumber}`),
          callback: () => {
            countdown()
            setMode('verifyOpt')
          },
        });
      }
    } else if (mode === 'verifyOpt') {
      verifyOtp({
        code: fixNumbers(`${code}`),
        phoneNumber: changePhoneNumberFormatTo98(fixNumbers(`${phoneNumber}`)),
        rememberMe: true,
      });
    }
  };
  const changeModeLogin = (mode: string) => {
    setMode(mode);
  };

  const generateDemoOtp = async (payload: any) => {
    setLoading(true)
    try {
      const { response } = await loginRepository.generateDemoOpt({ payload })
      countdown()
      setMode('verifyOpt')
      setLoading(false)
    } catch (err) {
      if (err?.response?.data?.message === "error.otp.notExpired") {
        handleNotfication("کد ارسال شده قبلی را وارد نمایید.", "warn")
        countdown()
        setMode('verifyOpt')
      } else {
        handleError(err)
      }
      setLoading(false)
    }
  }

  const generateOtp = async (payload: any) => {
    setLoading(true)
    try {
      const { response } = await loginRepository.generateOpt({ payload })
      setMode('verifyOpt')
      countdown()
      response.data && localStorage.setItem('token', response.data.token);
      response.data && localStorage.setItem('role', response.data.role);
      setLoading(false)
    } catch (err) {
      handleNotfication("شماره موبایل در سیستم ثبت نشده است.", "error")
      setLoading(false)
    }
  }

  const verifyOtp = async (payload: any) => {
    setLoading(true)
    try {
      const response = await loginRepository.verifyOpt({ payload })
      handleNotfication('ورود با موفقیت انجام شد', 'success');
      window.location.pathname !== '/login'
        ? window.location.reload()
        : window.location.pathname = '/orders'
      response.data && localStorage.setItem('token', response.data.token);
      response.data && localStorage.setItem('role', response.data.role);
      response.data?.partnerId && localStorage.setItem('partnerId', response.data.partnerId);
      setLoading(false)
    } catch (err) {
      handleNotfication("ورود ناموفق، لطفا دوباره امتحان نمایید.", "error")
      setLoading(false)
    }
  }

  const regenerateOtp = () => {
    if (process.env.REACT_APP_ENVIROMENT == "sandbox") {
      generateDemoOtp({
        phoneNumber: changePhoneNumberFormatTo98(fixNumbers(`${phoneNumber}`)),
      })
    } else {
      generateOtp({
        phoneNumber: fixNumbers(`${phoneNumber}`),
        callback: () => {
          countdown()
          setMode('verifyOpt')
        },
      });
    }
  }
  const urlToRedircet = getEnv().account + '/protocol/openid-connect/auth?client_id=ronad&response_type=code&redirect_uri=' +
    encodeURIComponent(`${getEnv().panel}/r2`)
  const classes = useStyles();

  useEffect(() => {
    if (process.env.REACT_APP_ENVIROMENT !== 'qa'  && process.env.REACT_APP_ENVIROMENT !== 'sandbox') {
      setTimeout(() => {
        location.href = urlToRedircet
      }, 10000);
    }
    if (queryValues.phoneNum) {
      changeModeLogin('generateOpt');
      setPhoneNumber(queryValues.phoneNum.toString());
    }
    if (process.env.REACT_APP_ENVIROMENT == "sandbox") {
      setMode("generateOpt")
    }
    localStorage.clear()
  }, [])
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />

      </Helmet>
      <Grid container component="main" className={classes.root}>
        <Grid
          item
          xs={12}
          md={4}
          component={Paper}
          square
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <div className={classes.paper}>
            <Avatar
              className={classes.avatar}
              src="/login-logo.svg"
              variant="square"
            />
            <Typography component="h1" variant="h6" style={{ marginBottom: "10px", color: '#24388D' }}>
              {'به سامانه هوشمند پردازش سفارشات روناد'}
            </Typography>
            {process.env.REACT_APP_ENVIROMENT === "sandbox" ?
              <Typography component="h1" variant="h6" color='login' style={{ marginBottom: "30px", color: '#24388D' }}>
                {'خوش آمدید'}
                <span style={{ fontSize: "1.3rem", fontWeight: "bold" }}>{' (نسخه دمو)'}</span>
              </Typography> :
              <Typography component="h1" variant="h6" color='login' style={{ marginBottom: "30px", color: '#24388D' }}>
                {'خوش آمدید'}
              </Typography>}
            {phoneNumber && mode === 'verifyOpt' && (
              <Fragment>
                <Typography variant="caption" display="block" gutterBottom>
                  کد تایید به شماره همراه &nbsp;{phoneNumber}&nbsp; ارسال شد
                </Typography>
                <Grid item xs>
                  <span>اصلاح</span>
                  <Button
                    color="secondary"
                    onClick={() => changeModeLogin('generateOpt')}
                  >
                    شماره همراه
                  </Button>
                </Grid>
              </Fragment>
            )}
            <form className={classes.form}>
              {(process.env.REACT_APP_ENVIROMENT === 'qa' || process.env.REACT_APP_ENVIROMENT === 'sandbox') &&
                <div className={classes.formContainer}>
                  <p className={classes.label}>هنوز از طریق پنل‌تان احراز هویت نکرده‌اید؟</p>
                  {mode === 'default' && (
                    <>
                      <div className={classes.item}>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="email"
                            // label="ایمیل "
                            placeholder='ایمیل'
                            name="emailAddress"
                            autoFocus
                            value={emailAddress}
                            InputProps={{
                              startAdornment: (
                                <RonadIcons name='mailOutline'
                                  size={1}
                                  className={classes.icon}
                                />
                              ),
                            }}
                            onChange={handleChangeEmailAddress}
                            style={{ backgroundColor: 'white' }}
                          />
                        </Grid>
                      </div>
                      <div className={classes.item}>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            style={{ backgroundColor: 'white !important' }}
                            margin="normal"
                            fullWidth
                            name="password"
                            placeholder="رمز عبور"
                            type={hide ? 'password' : 'text'}
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={handleChangePassword}
                            InputProps={{
                              startAdornment: (
                                <RonadIcons name='key'
                                  className={classes.icon}
                                />
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton onClick={() => setHide(!hide)}>
                                    <RonadIcons name={hide ? "eyeOff" : "eye"} className={classes.icon} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />{' '}
                        </Grid>
                      </div>

                      {shoudShowhint && <Typography className={classes.infoContainer}>
                        ثبت نام شما در سامانه احراز هویت مرکزی انجام شده است. از این پس باید با نام کاربری و کلمه عبور جدید و تنها از طریق احراز هویت مرکزی به حساب خود وارد شوید.

                      </Typography>}
                    </>
                  )}
                  {mode === 'generateOpt' && (
                    <>
                      <div className={classes.item}>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            margin="normal"
                            id="phoneNumber"
                            fullWidth
                            placeholder="شماره موبایل(09123456789)"
                            InputProps={{
                              startAdornment: (
                                <RonadIcons name='callBlack' size={1} className={classes.icon} />
                              )
                            }}
                            name="phoneNumber"
                            autoFocus
                            value={phoneNumber}
                            onChange={handleChangePhoneNumber}
                          />
                          {error && <p className={classes.errorMsg}>شماره تلفن اشتباه است</p>}
                        </Grid>
                      </div>
                    </>
                  )}
                  {mode === 'verifyOpt' && (
                    <>
                      <div className={classes.item}>
                        <Grid item xs={12}>
                          <TextField
                            variant="standard"
                            margin="normal"
                            id="code"
                            placeholder="کد تایید"
                            name="code"
                            InputProps={{
                              startAdornment: (
                                <RonadIcons name='key'
                                  className={classes.icon}
                                />
                              ),
                            }}
                            fullWidth
                            autoFocus
                            value={code}
                            onChange={handleChangeCode}
                          />
                        </Grid>
                      </div>
                    </>
                  )}
                  {mode === 'default' && (
                    <Button
                      type="submit"
                      variant="contained"
                      color="login-primary"
                      style={{ minWidth: '25%', backgroundColor: '#24388D', color: 'white' }}
                      className={classes.submit}
                      onClick={e => onSubmit(e)}
                      disabled={loading}
                    >
                      {mode === 'default' && 'ورود'}
                      {loading && <CircularProgress size={24} />}
                    </Button>
                  )}


                  {mode === 'verifyOpt' && (
                    <Button
                      type="submit"
                      variant="contained"
                      // color="login-primary"
                      // style={{ minWidth: '25%', marginTop: '60px', color: '#24388D' }}
                      className={classes.submit}
                      onClick={e => onSubmit(e)}
                      disabled={loading || code.length === 0}
                    >
                      {mode === 'verifyOpt' && 'ورود'}
                      {loading && <CircularProgress size={24} />}
                    </Button>
                  )}
                  {mode === 'generateOpt' && (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      // style={{ minWidth: '25%', marginTop: '60px', color: 'white', backgroundColor: '#24388D' }}
                      className={classes.submit}
                      onClick={e => onSubmit(e)}
                      disabled={phoneNumber.length == 0 || loading}
                    >
                      {mode === 'generateOpt' && 'دریافت کد تایید'}

                      {loading && <CircularProgress size={24} />}
                    </Button>
                  )}
                  {mode === 'verifyOpt' && compeleteTimer && (
                    <div>
                      <Button
                        onClick={e => regenerateOtp()}
                      >
                        ارسال مجدد کد
                      </Button>
                    </div>
                  )}
                </div>


              }
              <a href={urlToRedircet}>
                <Button fullWidth variant='contained' color='primary'>ورود با احراز هویت مرکزی</Button>
              </a>
              {!compeleteTimer && <div ref={timeRef}></div>}
            </form>
          </div>
        </Grid>
        <Grid item md={8} xs={false} className={classes.imageContainer}>
          <Grid item xs={false} className={classes.image} />
        </Grid>
      </Grid>
    </>
  );
}

export default Login;
